import {
  DAHTNumericalValues,
  DAHTSecondOpinion,
} from '@dermloop/static-values';
import type { DAHTNumericalValue } from '@dermloop/static-values';
import {
  IsBoolean,
  IsEnum,
  IsIn,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  ValidateIf,
} from 'class-validator';
import type { DiagnosisGroupDto } from '../diagnoses';
import type { DAHTLesionDto } from './condition.dto';

export class UpdateDAHTAssessmentDto {
  @IsUUID()
  @IsNotEmpty()
  selectedDiagnosisGroupId: string;

  @IsOptional()
  selectedDiagnosisGroup?: DiagnosisGroupDto;

  @IsString()
  @IsOptional()
  otherDiagnosis: string;

  @IsNumber()
  @IsNotEmpty()
  timeSpentMs: number;

  @IsIn(DAHTNumericalValues)
  confidence: DAHTNumericalValue;

  @IsIn(DAHTNumericalValues)
  difficulty: DAHTNumericalValue;

  @IsNotEmpty()
  @IsEnum(DAHTSecondOpinion)
  secondOpinion: DAHTSecondOpinion;

  @IsNotEmpty()
  @IsBoolean()
  additionalStainsHelpful: boolean;

  @ValidateIf((o: UpdateDAHTAssessmentDto) => o.additionalStainsHelpful)
  @IsNotEmpty()
  @IsString()
  additionalStainsHelpfulDetails: string;

  @IsString()
  @IsOptional()
  comment: string;

  @IsOptional()
  @IsBoolean()
  clickedClinicalInfo?: boolean;

  @IsOptional()
  @IsBoolean()
  clickedClinicalImage?: boolean;

  @IsOptional()
  @IsBoolean()
  clickedDermoscopicImage?: boolean;

  @IsOptional()
  @IsBoolean()
  clickedHistologicalImage?: boolean;

  @IsOptional()
  @IsBoolean()
  clickedAlternativeStain?: boolean;
}

export class DAHTAssessmentDto {
  id: string;
  order: number;
  assessedDate: string | Date;
  lesion: DAHTLesionDto;
  selectedDiagnosisGroupId?: string;
  selectedDiagnosisGroup?: DiagnosisGroupDto;
  otherDiagnosis?: string;
  clickedClinicalInfo?: boolean;
  clickedClinicalImage?: boolean;
  clickedDermoscopicImage?: boolean;
  clickedHistologicalImage?: boolean;
  clickedAlternativeStain?: boolean;
}
